import styled from 'styled-components';

export const DatatableStyledWrapper = styled.div`
  th,
  td {
    z-index: 1;
  }
`;
